import { render, staticRenderFns } from "./DentEdit.vue?vue&type=template&id=293100e5&scoped=true&"
import script from "./DentEdit.vue?vue&type=script&lang=js&"
export * from "./DentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293100e5",
  null
  
)

export default component.exports